// extracted by mini-css-extract-plugin
export var divider = "_1j-0";
export var dividerText = "_1j-1";